module.exports = __webpack_public_path__ + "static/index/img/baikal-204.4ac5e731.jpg";